/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudArrowDownloadIcon24Solid = forwardRef('NetCloudArrowDownloadIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6 16A5.5 5.5 0 0 1 4.65 5.192a6.602 6.602 0 0 1 12.43-1.39 6.1 6.1 0 1 1 .42 12.193V16h-4.25V9a1.25 1.25 0 1 0-2.5 0v7H6Z" }),
        React.createElement("path", { d: "M10.75 20.358V16h2.5v4.358l2.082-2.008a1.25 1.25 0 0 1 1.736 1.8l-3.16 3.046a2.75 2.75 0 0 1-3.817 0L6.932 20.15a1.25 1.25 0 0 1 1.736-1.8l2.082 2.008Z" })));
});
